import React, { useCallback, useEffect, useMemo, useState } from "react";
import { GetAddress, GetShares, GetSharesWith, getInfo, DeleteSecondaryToken, DeletePrimaryToken, GetRequestDetails, CreateSecondaryToken, GetServiceProvider, GetBeneficiary, GetSecuredContent, GetSharedSecuredContent, GetTemplateByID, GetTemplatesByServiceProviderID, GetSharedStream, GetStream } from "../utilities/calls";
import Login from "./Login";
import DeleteModal from "./DeleteModal";
import AddressBox from "./AddressBox";
import ContentBox from "./SecuredContentBox";
import { FirstMatchedTemplate, ProcessTemplate } from "../utilities/templates";
import StreamBox from "./StreamBox";
import ShareFiltersBar from "./ShareFiltersBar";
import { parseSharedWithParam } from "../utilities/functions";
import { useLocation } from "react-router-dom";
import { matchesFilters, normalizeShareFilters } from "../utilities/shareFilters";


const IndividualShares = () => {
    const [addresses, setAddresses] = useState([]);
    const [addressesSharedWithBene, setAddressesSharedWithBene] = useState([]);
    const [addressesSharedWithSP, setAddressesSharedWithSP] = useState([]);

    const [shares, setShares] = useState([]);
    const [spShares, setSpShares] = useState([]);
    const [sharesWithBen, setSharesWithBen] = useState([]);
    const [userId, setUserId] = useState();
    const [showAlert, setShowAlert] = useState();
    const [alertText, setAlertText] = useState();
    const [showDeleteDlg, setShowDeleteDlg] = useState();
    const [confirmationText, setConfirmationText] = useState();
    const [currShare, setCurrShare] = useState();
    const [sP, setSP] = useState();
    const [refBens, setRefBens] = useState({});
    const [rNote, setRNote] = useState({});
    const [benList, setBenList] = useState({});
    const [spList, setSpList] = useState({});
    const [securedContents, setSecuredContents] = useState([]);
    const [streams, setStreams] = useState([]);
    let spIds = [];
    const [dataReady, setDataReady] = useState(false);
    const [filters, setFilters] = useState({
        contentType: "",
        searchText: "",
        sharedWith: [],
        sharedWithText: "",
    });
    let location = useLocation();
    const [groupByMe, setGroupByMe] = useState(localStorage.getItem(document.location.hostname + '.shares.groupByMe') || "none");
    const [groupBySP, setGroupBySP] = useState(localStorage.getItem(document.location.hostname + '.shares.groupBySP') || "none");
    const [groupByBen, setGroupByBen] = useState(localStorage.getItem(document.location.hostname + '.shares.groupByBen') || "none");

    const addressById = useMemo(
        () => Object.fromEntries(addresses.map(a => [a?.id, a])),
        [addresses]
    );

    const addressSPById = useMemo(
        () => Object.fromEntries(addressesSharedWithSP.map(a => [a?.id, a])),
        [addressesSharedWithSP]
    );

    const addressBenById = useMemo(
        () => Object.fromEntries(addressesSharedWithBene.map(a => [a?.id, a])),
        [addressesSharedWithBene]
    );

    const contentById = useMemo(
        () => Object.fromEntries(securedContents.map(c => [c.id, c])),
        [securedContents]
    );

    const streamById = useMemo(
        () => Object.fromEntries(streams.map(s => [s.ID, s])),
        [streams]
    );


    useEffect(() => {
        if (!dataReady) return;

        const params = new URLSearchParams(location.search);
        const contentType = params.get("type") || "";
        const searchText = params.get("q") || "";
        const sharedWithParam = params.get("sharedWith") || "";

        const parsed = parseSharedWithParam(sharedWithParam);

        if (parsed.length > 0) {
            setFilters((prev) => ({
                ...prev,
                contentType,
                searchText,
                sharedWith: parsed,
                sharedWithText: "",
            }));
            setSharedWithInput("");
        }
        else if (sharedWithParam) {
            setFilters((prev) => ({
                ...prev,
                contentType,
                searchText,
                sharedWith: [],
                sharedWithText: sharedWithParam,
            }));
            setSharedWithInput(sharedWithParam);
        }
        else {
            setFilters((prev) => ({
                ...prev,
                contentType,
                searchText,
                sharedWith: [],
                sharedWithText: "",
            }));
            setSharedWithInput("");
        }
    }, [dataReady, location.search]);

    const [sharedWithInput, setSharedWithInput] = useState("");
    const [sharedWithSuggestions, setSharedWithSuggestions] = useState([]);

    const [templates, setTemplates] = useState([{
        Name: "Documents", Tags: {
            "DisplayName": {
                "Name": "DisplayName",
                "Value": "Documents",
                "Private": false,
                "Required": true,
                "Editable": false
            }
        }
    }, {
        Name: "Addresses", Tags: {
            "DisplayName": {
                "Name": "DisplayName",
                "Value": "Addresses",
                "Private": false,
                "Required": true,
                "Editable": false
            }
        }
    }]);
    let timer = undefined;

    const getTemplates = useCallback((spid) => {
        GetTemplatesByServiceProviderID(spid).then((templateIdsArr) => {
            templateIdsArr.forEach((id) => {
                if (templates.find(t => t.id === id)) {
                    return;
                }
                GetTemplateByID(id).then((template) => {
                    setTemplates((templates) => [...templates, template]);
                }).catch(err => console.log('Error fetching templates for spid ', spid, err));
            })
        }).catch(err => console.log('Error fetching templates for spid ', spid, err));
    }, [templates]);

    useEffect(() => {
        setUserId(getInfo("UserID"));
        setShowDeleteDlg(false);
        let defaultSP = getInfo('DefaultServiceProvider');
        if (defaultSP) {
            spIds.push(defaultSP);
            getTemplates(defaultSP);
        }
        return () => clearTimeout(timer);
    }, [timer]);

    const getSharesWithBene = useCallback(() => {
        const individualid = getInfo("IndividualID");
        const ownertoken = getInfo("Ownertoken")
        GetShares(individualid)
            .then((data) => {

                let ben = data.filter((d) => d.beneficiaryID?.localeCompare("00000000-0000-0000-0000-000000000000") !== 0);
                setSharesWithBen(ben);

                ben.forEach((b) => {
                    if (b.serviceProviderID?.localeCompare("00000000-0000-0000-0000-000000000000") !== 0)
                        GetBeneficiary(b.beneficiaryID).then((el) => setBenList((benList) => ({ ...benList, [b.beneficiaryID]: el }))).catch((err) => console.log(err))

                })

                Promise.all(
                    ben.filter(d => d.securedcontentID === "" && d.streamID === "").map(async (el) => {
                        try {
                            const result = await GetAddress(
                                el.addressID,
                                "",
                                ownertoken,
                                el.individualID
                            );

                            return result;
                        } catch (err) {
                            console.error("Error fetching addresses:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((addrs) => {
                        setAddressesSharedWithBene((addressesSharedWithBene) => [
                            ...addressesSharedWithBene,
                            ...addrs,
                        ]);
                    })
                    .catch((e) => {
                        console.log(e);
                    });
                Promise.all(
                    ben.filter(d => d.securedcontentID !== "").map(async (el) => {
                        try {
                            return await GetSecuredContent(el.securedcontentID);
                        } catch (err) {
                            console.error("Error fetching secured content:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((contents) => {
                        setSecuredContents((securedContents) => [...securedContents, ...contents]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });

                Promise.all(
                    ben.filter(d => d.streamID !== "").map(async (el) => {
                        try {
                            return await GetStream(el.streamID);
                        } catch (err) {
                            console.error("Error fetching documents:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((streams) => {
                        setStreams((prev) => [...prev, ...streams]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });
                let sp = data.filter((d) => d.beneficiaryID?.localeCompare("00000000-0000-0000-0000-000000000000") === 0);
                setSpShares(spShares => [...spShares, ...sp]);

                Promise.all(
                    sp.filter(d => d.securedcontentID === "" && d.streamID === "").map(async (el) => {

                        try {
                            const result = await GetAddress(
                                el.addressID,
                                "",
                                ownertoken,
                                el.individualID
                            );

                            return result;
                        } catch (err) {
                            console.error("Error fetching addresses:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((addrs) => {
                        setAddressesSharedWithSP((addressesSharedWithSP) => [
                            ...addressesSharedWithSP,
                            ...addrs,
                        ]);
                    })
                    .catch((e) => {
                        console.log(e);
                    });
                Promise.all(
                    sp.filter(d => d.securedcontentID !== "").map(async (el) => {
                        try {
                            return await GetSecuredContent(el.securedcontentID);
                        } catch (err) {
                            console.error("Error fetching secured content:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((contents) => {
                        setSecuredContents((securedContents) => [...securedContents, ...contents]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });
                Promise.all(
                    sp.filter(d => d.streamID !== "").map(async (el) => {
                        try {
                            return await GetStream(el.streamID);
                        } catch (err) {
                            console.error("Error fetching document:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((streams) => {
                        setStreams((prev) => [...prev, ...streams]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });
                sp.forEach((s) => {
                    try {
                        if (spIds.findIndex((v) => v === s.serviceProviderID) === -1) {
                            spIds.push(s.serviceProviderID)
                            getTemplates(s.serviceProviderID);
                        }
                        GetServiceProvider(s.serviceProviderID).then((el) => setSpList((spList) => ({ ...spList, [s.serviceProviderID]: el }))).catch((err) => console.log(err))


                        return GetRequestDetails(s.tags?.RequestId?.Value).then((r) => {
                            const refs = r.tags?.beneficiaryReference?.Value || [];
                            setRNote((rNote) => ({ ...rNote, [s?.tags?.RequestId?.Value]: r.tags?.note?.Value || "" }))
                            setRefBens((refBens) => ({ ...refBens, [s?.tags?.RequestId?.Value]: refs }));
                            if (refs.length > 0)
                                GetBeneficiary(refs[0]).then((el) => setBenList((benList) => ({ ...benList, [refs[0]]: el }))).catch((err) => console.log(err))

                        }).catch((err) => {
                            console.log(err);
                        });

                    } catch (err) {
                        console.error("Error fetching request details:", err);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    }
                })
            })
            .catch((error) => {
                console.error("Error fetching shares:", error);
                setShowAlert(true);
                setAlertText("Error fetching data");
            });
    }, [getTemplates]);

    useEffect(() => {
        const individualid = getInfo("IndividualID");

        GetSharesWith(individualid)
            .then((data) => {
                setShares(data);
                Promise.all(
                    data.filter(d => d.securedcontentID === "" && d.streamID === "").map(async (el) => {
                        try {
                            const benId = el.tags?.RequestId ? "" : el.beneficiaryID
                            const result = await GetAddress(
                                el.addressID,
                                benId,
                                el.token,
                                el.individualID
                            );

                            return result;
                        } catch (err) {
                            console.error("Error fetching addresses:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((addrs) => {
                        setAddresses((addresses) => [...addresses, ...addrs]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });
                Promise.all(
                    data.filter(d => d.securedcontentID === "" && d.streamID !== "").map(async (el) => {
                        const benId = el.tags?.RequestId ? el.beneficiaryID : ""

                        try {
                            return await GetSharedStream(el.streamID, el.token, benId, el.individualID);
                        } catch (err) {
                            console.error("Error fetching documents:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((streams) => {
                        setStreams((prev) => [...prev, ...streams]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });
                Promise.all(
                    data.filter(d => d.securedcontentID !== "").map(async (el) => {
                        const benId = el.tags?.RequestId ? el.beneficiaryID : ""
                        try {
                            return await GetSharedSecuredContent(el.securedcontentID, el.token, benId, el.individualID);
                        } catch (err) {
                            console.error("Error fetching secured content:", err);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                        }
                    })
                )
                    .then((contents) => {
                        setSecuredContents((securedContents) => [...securedContents, ...contents]);
                    })
                    .catch((e) => {
                        console.log(e);
                        setShowAlert(true);
                        setAlertText("Error fetching data");
                    });
            })
            .catch((error) => {
                console.error("Error fetching sharedWith:", error);
                setShowAlert(true);
                setAlertText("Error fetching data");
            }).finally(() => {
                setDataReady(true);
            });
        getSharesWithBene();
    }, []);



    const deleteServiceProviderShare = () => {
        setShowDeleteDlg(false);

        const shareReq = currShare

        DeletePrimaryToken(shareReq.serviceProviderID, shareReq.individualID, shareReq.addressID, shareReq.securedcontentID, shareReq.streamID)
            .then((response) => {
                setShowAlert(true);
                setAlertText("Removed share successfully.");
                timer = setTimeout(() => {
                    setShowAlert(false);
                }, 2000);
                setAddressesSharedWithSP([])
                setAddressesSharedWithBene([])
                setSharesWithBen([]);
                setSpShares([]);
                getSharesWithBene();
            })
            .catch((error) => {
                console.error("Error removing share", error);
                setShowAlert(true);
                setAlertText("Error removing a share.");
            });
    }

    const deleteShare = () => {
        setShowDeleteDlg(false);
        if (sP) { deleteServiceProviderShare(); return; }
        const shareReq = currShare;
        var addressOffered = !shareReq.tags?.RequestId
        let id = shareReq.serviceProviderID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? (addressOffered ? shareReq.tags.SharedWithEmail.Value : "") : shareReq.beneficiaryID;

        DeleteSecondaryToken("", id, shareReq.token)
            .then((response) => {
                setShowAlert(true);
                setAlertText("Removed share successfully.");
                timer = setTimeout(() => {
                    setShowAlert(false);
                }, 2000);
                setAddressesSharedWithBene([])
                setAddressesSharedWithSP([])
                setSharesWithBen([]);
                setSpShares([]);
                getSharesWithBene();
            })
            .catch((error) => {
                console.error("Error removing share", error);
                setShowAlert(true);
                setAlertText("Error removing a share.");

            });
    }
    const handleDeleteClick = (share, sp) => {
        setConfirmationText("Are you certain you wish to Remove the sharing of this address?")
        setShowDeleteDlg(true);
        setCurrShare(share);
        setSP(sp)
    }

    const handleContentTypeChange = (value) => {
        setFilters((prev) => ({
            ...prev,
            contentType: value,
        }));
    };

    const connect = (sp, address, content, stream) => {
        if (content && content !== "") {
            const shareReq = spShares.find((el) => el.securedcontentID === content.id && sp.serviceProviderID === el.serviceProviderID);
            CreateSecondaryToken(shareReq.serviceProviderID, refBens[sp?.tags?.RequestId?.Value][0], shareReq.token).then((resp) => {
                setShowAlert(true);
                setAlertText("You have connected with the recommended beneficiary! ");
                timer = setTimeout(() => {
                    setShowAlert(false);
                }, 2000);
                setAddressesSharedWithBene([])
                setAddressesSharedWithSP([])
                setSpShares([])
                getSharesWithBene();
            }).catch((err) => { console.log('error creating secondary token', err) })
        } else if (stream && stream !== "") {
            const shareReq = spShares.find((el) => el.streamID === stream.ID && sp.serviceProviderID === el.serviceProviderID);
            CreateSecondaryToken(shareReq.serviceProviderID, refBens[sp?.tags?.RequestId?.Value][0], shareReq.token).then((resp) => {
                setShowAlert(true);
                setAlertText("You have connected with the recommended beneficiary! ");
                timer = setTimeout(() => {
                    setShowAlert(false);
                }, 2000);
                setAddressesSharedWithBene([])
                setAddressesSharedWithSP([])
                setSpShares([])
                getSharesWithBene();
            }).catch((err) => { console.log('error creating secondary token', err) })
        } else {
            const shareReq = spShares.find((el) => el.addressID === address.id && sp.serviceProviderID === el.serviceProviderID);
            CreateSecondaryToken(shareReq.serviceProviderID, refBens[sp?.tags?.RequestId?.Value][0], shareReq.token).then((resp) => {
                setShowAlert(true);
                setAlertText("You have connected with the recommended beneficiary! ");
                timer = setTimeout(() => {
                    setShowAlert(false);
                }, 2000);
                setAddressesSharedWithBene([])
                setAddressesSharedWithSP([])
                setSpShares([])
                getSharesWithBene();
            }).catch((err) => { console.log('error creating secondary token', err) })
        }
    }

    const contentTypeOptions = useMemo(() => {
        return templates
            .slice()
            .sort((a, b) =>
                (a?.Tags?.DisplayName?.Value || a?.Name)
                    ?.toLowerCase()
                    .localeCompare(
                        (b?.Tags?.DisplayName?.Value || b?.Name)?.toLowerCase()
                    )
            )
            .map((t) => ({
                value: t.Name,
                label: t?.Tags?.DisplayName?.Value || t.Name,
            }));
    }, [templates]);
    const sharedWithSource = useMemo(() => {
        const spEntities = Object.entries(spList).map(([id, sp]) => ({
            id,
            label: sp?.tags?.name?.Value || "Unknown Service Provider",
            type: "sp",
        }));

        const benEntities = Object.entries(benList).map(([id, ben]) => ({
            id,
            label: ben?.tags?.name?.Value || "Unknown Beneficiary",
            type: "ben",
        }));

        return [...spEntities, ...benEntities];
    }, [spList, benList]);

    useEffect(() => {
        if (!sharedWithInput) {
            setSharedWithSuggestions([]);
            return;
        }

        const q = sharedWithInput.toLowerCase();

        const matches = sharedWithSource
            .filter((e) => e.label.toLowerCase().includes(q))
            .slice(0, 8); // limit suggestions

        setSharedWithSuggestions(matches);
    }, [sharedWithInput, sharedWithSource]);

    const handleAddSharedWith = (entity) => {
        setFilters((prev) => ({
            ...prev,
            sharedWith: [...prev.sharedWith, entity],
            sharedWithText: "",
        }));
        setSharedWithInput("");
        setSharedWithSuggestions([]);
    };

    const handleRemoveSharedWith = (id) => {
        setFilters((prev) => {
            const remaining = prev.sharedWith.filter((e) => e.id !== id);

            return {
                ...prev,
                sharedWith: remaining,
                sharedWithText: remaining.length === 0 ? prev.sharedWithText : "",
            };
        });
    };
    const renderGroupBySelect = ({ value, onChange, options }) => {
        return (
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="px-2 py-1 text-sm rounded-md  bg-gray-700 border border-gray-600  text-white"
            >
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        );
    };

    const getSharedWithGroupKey = ({ share }) => {
        const email = share?.tags?.SharedWithEmail?.Value;
        if (email) {
            return `email:${decodeURIComponent(email)}`;
        }
        if (
            share?.beneficiaryID &&
            share.beneficiaryID !== "00000000-0000-0000-0000-000000000000"
        ) {
            return `ben:${share.beneficiaryID}`;
        }

        if (
            share?.serviceProviderID &&
            share.serviceProviderID !== "00000000-0000-0000-0000-000000000000"
        ) {
            return `sp:${share.serviceProviderID}`;
        }

        

        return "unknown";
    };

    const getGroupName = (groupKey, groupBy) => {
        let groupName = groupKey;
        if (groupBy === "sharedWith") {
            if (groupKey.startsWith("ben:")) {
                const id = groupKey.replace("ben:", "");
                groupName =
                    benList?.[id]?.tags?.name?.Value || "" ;
                groupName += "[" + id + "]";
            }
            else if (groupKey.startsWith("sp:")) {
                const id = groupKey.replace("sp:", "");
                groupName =
                    spList?.[id]?.tags?.name?.Value || "Unknown Service Provider";
                groupName += "[" + id + "]";
            }
            else if (groupKey.startsWith("email:")) {
                groupName = groupKey.replace("email:", "");
            }
        }
        return groupName;
    }


    const renderGroupedShares = ({
        items,
        groupBy,
        resolveEntities,
        renderItem,
    }) => {
        if (!items || items.length === 0) return null;

        // -------- group data --------
        if (groupBy === "none") {
            return (
                <div className="flex flex-wrap gap-2 p-3">
                    {items.map(renderItem)}
                </div>
            );
        }
        const grouped = items.reduce((acc, item) => {
            const { address, content, stream, share } =
                resolveEntities(item);

            let key = "Others";

            if (groupBy === "contentType") {
                if (address) key = "Addresses";
                else if (stream) key = "Documents";
                else if (content) {
                    const tpl = FirstMatchedTemplate(content, templates);
                    key =
                        tpl?.Tags?.DisplayName?.Value ||
                        tpl?.Name ||
                        "Content";
                }
            }

            if (groupBy === "sharedBy") {
                key = decodeURIComponent(
                    share?.tags?.UserEmail?.Value || "Unknown"
                );
            }

            if (groupBy === "sharedWith") {
                key = getSharedWithGroupKey({ share });
            }

            if(groupBy === "contentID") {
                if(address) {
                    const name = address?.tags?.atag?.Name
                    key = (name ? name: "Untitled") + "[" + address.id + "]";
                }
                else if(stream) {
                    const name = stream?.tags?.Name?.Value;
                    key = (name ? name : "Untitled") + "[" + stream.ID + "]";
                }
                else if(content) {
                    const tpl = ProcessTemplate(FirstMatchedTemplate(content, templates));
                    const name = content.tags[tpl?.contentNameTag]?.Value;
                    key = (name? name: "Untitled") + "[" + content.id + "]";
                } 
            }

            if (!acc[key]) acc[key] = [];
            acc[key].push(item);
            return acc;
        }, {});

        // -------- render --------
        return Object.entries(grouped).map(([groupName, groupItems]) => (
            <div
                key={groupName}
                className="mb-6 rounded-lg bg-gray-950 border border-gray-800"
            >
                {groupBy !== "none" && (
                    <div className="flex items-center justify-start gap-3 px-4 py-2 border-b border-gray-700">
                        <h3 className="text-sm font-medium tracking-wider text-gray-300">
                            {getGroupName(groupName, groupBy)}
                        </h3>
                        <span className="bg-gray-800 border border-gray-700 text-white text-xs font-semibold px-2 py-1 rounded-full">
                            {groupItems.length}
                        </span>
                    </div>
                )}

                <div className="flex flex-wrap gap-2 p-3">
                    {groupItems.map(renderItem)}
                </div>
            </div>
        ));

    };

    const getEmptyMessage = (filters, base) =>
        filters.searchText || filters.contentType || filters.sharedWithText || filters.sharedWith.length
            ? "No matching content found."
            : base;
    const EmptyState = ({ message }) => (
        <div className="w-full p-5 text-left">
            <div className="text-sm text-gray-400">
                {message}
            </div>
        </div>
    );

    const filteredSharesWithMe = useMemo(() => (shares.filter((share) =>
        matchesFilters(
            normalizeShareFilters({
                share,
                content: contentById[share.securedcontentID],
                stream: streamById[share.streamID],
                address: addressById[share.addressID],
                filters,
                templates,
            })
        )
    )), [addressById, contentById, filters, shares, streamById, templates]);

    const filteredSharesWithSP = useMemo(() => (spShares.filter((share) =>
        matchesFilters(
            normalizeShareFilters({
                share,
                content: contentById[share.securedcontentID],
                stream: streamById[share.streamID],
                address: addressSPById[share.addressID],
                filters,
                templates,
                serviceProvider:
                    spList[share.serviceProviderID]?.tags?.name?.Value,
            })
        )
    )), [addressSPById, contentById, filters, spList, spShares, streamById, templates]);

    const filteredSharesWithBen = useMemo(() => (sharesWithBen.filter((share) =>
        matchesFilters(
            normalizeShareFilters({
                share,
                content: contentById[share.securedcontentID],
                stream: streamById[share.streamID],
                address: addressBenById[share.addressID],
                filters,
                templates,
                serviceProvider:
                    spList[share.serviceProviderID]?.tags
                        ?.name?.Value,
            })
        )
    )), [addressBenById, contentById, filters, sharesWithBen, spList, streamById, templates]);

    useEffect(() => {
        if (!dataReady) return;

        if (filteredSharesWithMe.length === 1 && (filters.searchText || filters.contentType || filters.sharedWithText || filters.sharedWith.length) && groupByMe !== "none") {
            setGroupByMe("none");
            localStorage.setItem(document.location.hostname + '.shares.groupByMe', 'none')
        }
    }, [filteredSharesWithMe.length, groupByMe, dataReady, filters]);

    useEffect(() => {
        if (!dataReady) return;

        if (filteredSharesWithSP.length === 1 && (filters.searchText || filters.contentType || filters.sharedWithText || filters.sharedWith.length) && groupBySP !== "none") {
            setGroupBySP("none");
            localStorage.setItem(document.location.hostname + '.shares.groupBySP', 'none')
        }
    }, [filteredSharesWithSP.length, groupBySP, dataReady, filters]);

    useEffect(() => {
        if (!dataReady) return;

        if (filteredSharesWithBen.length === 1 && (filters.searchText || filters.contentType || filters.sharedWithText || filters.sharedWith.length) && groupByBen !== "none") {
            setGroupByBen("none");
            localStorage.setItem(document.location.hostname + '.shares.groupByBen', 'none')
        }
    }, [filteredSharesWithBen.length, groupByBen, dataReady,filters]);


    return userId ? (

        <div className="px-1 md:px-4 py-3 max-w-screen-xl mx-auto items-center">
            <h1 className="bold-text-input">Secured Content Shares</h1>
            <DeleteModal confirmationText={confirmationText} deleteLabel="Remove Share" onDeleteFn={deleteShare} onCancelFn={() => { setShowDeleteDlg(false) }} show={showDeleteDlg} />

            <div
                class="  bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative"
                role="alert"
                style={{ display: showAlert ? "block" : "none" }}
            >                <button className="absolute top-2 right-1 text-lg font-normal text-gray-700 -translate-x-2 " onClick={() => { setShowAlert(false) }}>X</button>
                <span class="text-sm">{alertText} </span>
            </div>


            <div>
                <div className="p-5">
                    <ShareFiltersBar
                        filters={filters}
                        contentTypes={contentTypeOptions}

                        sharedWithInput={sharedWithInput}
                        sharedWithSuggestions={sharedWithSuggestions}

                        onContentTypeChange={handleContentTypeChange}
                        onSearchTextChange={(val) =>
                            setFilters((prev) => ({ ...prev, searchText: val }))
                        }

                        onSharedWithInputChange={(val) => {
                            setSharedWithInput(val);
                            setFilters((prev) => ({
                                ...prev,
                                sharedWithText: val.trim(),
                            }));
                        }}
                        onAddSharedWith={handleAddSharedWith}
                        onRemoveSharedWith={handleRemoveSharedWith}
                    />

                </div>

                <div className="flex items-center justify-between px-5 py-3">
                    <h1 className="text-base md:text-lg font-semibold text-gray-100 tracking-wide">Shared with me</h1>

                    {filteredSharesWithMe.length > 0 && renderGroupBySelect({
                        value: groupByMe,
                        onChange: (val) => {setGroupByMe(val);  localStorage.setItem(document.location.hostname + '.shares.groupByMe', val)},
                        options: [
                            { value: "none", label: "Group by: None" },
                            { value: "contentType", label: "Group by: Content type" },
                            { value: "sharedBy", label: "Group by: Shared by" },
                            {value: "contentID", label: "Group by: Content/Docs"}
                        ],
                    })}
                </div>
                <div class=" bg-gray  ">
                    <div class="max-w-full">

                        {filteredSharesWithMe.length === 0 ? (
                            <EmptyState
                                message={getEmptyMessage(filters, "No content shared with you.")}
                            />

                        ) : (renderGroupedShares({
                            items: filteredSharesWithMe,

                            groupBy: groupByMe, // "none" | "contentType" | "sharedBy"

                            resolveEntities: (share) => ({
                                share,
                                address: addressById[share.addressID],
                                content: contentById[share.securedcontentID],
                                stream: streamById[share.streamID]
                            }),

                            renderItem: (share) => {
                                const address = addressById[share.addressID];
                                const content = contentById[share.securedcontentID];
                                const matchedtemplate = FirstMatchedTemplate(
                                    content,
                                    templates
                                );
                                const stream = streamById[share.streamID];
                                const from = decodeURIComponent(
                                    share?.tags?.UserEmail
                                        ? share.tags.UserEmail.Value
                                        : ""
                                );
                                const to = decodeURIComponent(
                                    share?.tags?.SharedWithEmail
                                        ? share.tags.SharedWithEmail.Value
                                        : ""
                                );
                                const addressOffered = !share.tags?.RequestId;
                                if (address)
                                    return (
                                        <AddressBox
                                            key={share.id}
                                            created={share?.created || ""}
                                            updated={share?.updated || ""}
                                            address={address}
                                            from={from}
                                            to={to}
                                            sentBadge={addressOffered}
                                        />
                                    );

                                if (content)
                                    return (
                                        <ContentBox
                                            key={share.id}
                                            template={matchedtemplate}
                                            created={share?.created || ""}
                                            updated={share?.updated || ""}
                                            content={content}
                                            from={from}
                                            to={to}
                                        />
                                    );

                                if (stream)
                                    return (
                                        <StreamBox
                                            key={share.id}
                                            token={share.token}
                                            individualID={share.individualID}
                                            beneficiaryID={
                                                share.tags?.RequestId
                                                    ? share.beneficiaryID
                                                    : ""
                                            }
                                            created={share?.created || ""}
                                            updated={share?.updated || ""}
                                            stream={stream}
                                            from={from}
                                            to={to}
                                        />
                                    );

                                return null;
                            },
                        }))
                        }

                    </div>
                </div>
            </div>
            <div>
                <div className="flex items-center justify-between px-5 py-3">
                    <h1 className="text-base md:text-lg font-semibold text-gray-100 tracking-wide">Shared with Service Provider</h1>
                    {filteredSharesWithSP.length > 0 && renderGroupBySelect({
                        value: groupBySP,
                        onChange: (val) => {setGroupBySP(val);  localStorage.setItem(document.location.hostname + '.shares.groupBySP', val)} ,
                        options: [
                            { value: "none", label: "Group by: None" },
                            { value: "contentType", label: "Group by: Content type" },
                            { value: "sharedWith", label: "Group by: Shared with" },
                            {value: "contentID", label: "Group by: Content/Docs"}
                        ],
                    })}
                </div>
                <div class=" bg-gray ">
                    <div class=" max-w-full">
                        {filteredSharesWithSP.length === 0 ? (
                            <EmptyState
                                message={getEmptyMessage(filters, "No content shared with service providers.")}
                            />

                        ) :
                            renderGroupedShares({
                                items: filteredSharesWithSP,

                                groupBy: groupBySP, // none | contentType | sharedWith

                                resolveEntities: (share) => ({
                                    share,
                                    address: addressSPById[share.addressID],
                                    content: contentById[share.securedcontentID],
                                    stream: streamById[share.streamID]
                                }),

                                renderItem: (share) => {
                                    const address = addressSPById[share.addressID];
                                    const content = contentById[share.securedcontentID];
                                    const matchedtemplate = FirstMatchedTemplate(
                                        content,
                                        templates
                                    );
                                    const stream = streamById[share.streamID]
                                    const from = decodeURIComponent(
                                        share?.tags?.UserEmail?.Value || ""
                                    );
                                    const to = decodeURIComponent(
                                        share?.tags?.SharedWithEmail?.Value || ""
                                    );

                                    const bn =
                                        refBens[share?.tags?.RequestId?.Value] || [];
                                    const connected = sharesWithBen.find(
                                        el =>
                                            el.serviceProviderID ===
                                            share.serviceProviderID &&
                                            el.addressID === share.addressID
                                    );

                                    if (address)
                                        return (
                                            <AddressBox
                                                key={share.id}
                                                created={share?.created || ""}
                                                updated={share?.updated || ""}
                                                from={from}
                                                to={to}
                                                benList={benList}
                                                connected={connected}
                                                sharedTo={
                                                    spList[share.serviceProviderID]?.tags
                                                        ?.name?.Value
                                                }
                                                address={address}
                                                onDelete={() =>
                                                    handleDeleteClick(share, true)
                                                }
                                                ben={bn}
                                                message={
                                                    rNote[
                                                    share?.tags?.RequestId?.Value
                                                    ]
                                                }
                                                onConnect={() =>
                                                    connect(share, address)
                                                }
                                                serviceProviderId={
                                                    share.serviceProviderID
                                                }
                                            />
                                        );

                                    if (content)
                                        return (
                                            <ContentBox
                                                key={share.id}
                                                template={matchedtemplate}
                                                created={share?.created || ""}
                                                updated={share?.updated || ""}
                                                from={from}
                                                to={to}
                                                benList={benList}
                                                connected={connected}
                                                sharedTo={
                                                    spList[share.serviceProviderID]?.tags
                                                        ?.name?.Value
                                                }
                                                content={content}
                                                onDelete={() =>
                                                    handleDeleteClick(share, true)
                                                }
                                                ben={bn}
                                                message={
                                                    rNote[
                                                    share?.tags?.RequestId?.Value
                                                    ]
                                                }
                                                onConnect={() =>
                                                    connect(share, "", content)
                                                }
                                                serviceProviderId={
                                                    share.serviceProviderID
                                                }
                                            />
                                        );

                                    if (stream)
                                        return (
                                            <StreamBox
                                                key={share.id}
                                                created={share?.created || ""}
                                                updated={share?.updated || ""}
                                                from={from}
                                                to={to}
                                                benList={benList}
                                                connected={connected}
                                                sharedTo={
                                                    spList[share.serviceProviderID]?.tags
                                                        ?.name?.Value
                                                }
                                                stream={stream}
                                                onDelete={() =>
                                                    handleDeleteClick(share, true)
                                                }
                                                ben={bn}
                                                message={
                                                    rNote[
                                                    share?.tags?.RequestId?.Value
                                                    ]
                                                }
                                                onConnect={() =>
                                                    connect(share, "", "", stream)
                                                }
                                                serviceProviderId={
                                                    share.serviceProviderID
                                                }
                                            />
                                        );

                                    return null;
                                },
                            })
                        }

                    </div>
                </div>
            </div>
            <div>
                <div className="flex items-center justify-between px-5 py-3">
                    <h1 className="text-base md:text-lg font-semibold text-gray-100 tracking-wide">Shared with Beneficiary</h1>
                    {filteredSharesWithBen.length > 0 && renderGroupBySelect({
                        value: groupByBen,
                        onChange: (val) => {setGroupByBen(val);  localStorage.setItem(document.location.hostname + '.shares.groupByBen', val)} ,
                        options: [
                            { value: "none", label: "Group by: None" },
                            { value: "contentType", label: "Group by: Content type" },
                            { value: "sharedWith", label: "Group by: Shared with" },
                            {value: "contentID", label: "Group by: Content/Docs"}
                        ],
                    })}
                </div>
                <div class=" bg-gray ">
                    <div class=" max-w-full ">
                        {filteredSharesWithBen.length === 0 ? (
                            <EmptyState
                                message={getEmptyMessage(filters, "No content shared with beneficiaries.")}
                            />

                        ) :
                            renderGroupedShares({
                                items: filteredSharesWithBen,

                                groupBy: groupByBen, // none | contentType | sharedWith

                                resolveEntities: (share) => ({
                                    share,
                                    address: addressBenById[share.addressID],
                                    content: contentById[share.securedcontentID],
                                    stream: streamById[share.streamID]
                                }),

                                renderItem: (share) => {
                                    const address = addressBenById[share.addressID];
                                    const content = contentById[share.securedcontentID];
                                    const matchedtemplate = FirstMatchedTemplate(
                                        content,
                                        templates
                                    );
                                    const stream = streamById[share.streamID];
                                    const from = decodeURIComponent(
                                        share?.tags?.UserEmail?.Value || ""
                                    );
                                    const to = decodeURIComponent(
                                        share?.tags?.SharedWithEmail?.Value || ""
                                    );

                                    const sharedTo =
                                        benList[share.beneficiaryID]?.tags?.name
                                            ?.Value;

                                    if (address)
                                        return (
                                            <AddressBox
                                                key={share.id}
                                                created={share?.created || ""}
                                                updated={share?.updated || ""}
                                                from={from}
                                                to={to}
                                                sharedTo={sharedTo}
                                                address={address}
                                                onDelete={() =>
                                                    handleDeleteClick(share, false)
                                                }
                                                benId={share.beneficiaryID}
                                                token={
                                                    from !== ""
                                                        ? share?.token
                                                        : undefined
                                                }
                                            />
                                        );

                                    if (content)
                                        return (
                                            <ContentBox
                                                key={share.id}
                                                template={matchedtemplate}
                                                created={share?.created || ""}
                                                updated={share?.updated || ""}
                                                from={from}
                                                to={to}
                                                sharedTo={sharedTo}
                                                content={content}
                                                onDelete={() =>
                                                    handleDeleteClick(share, false)
                                                }
                                                benId={share.beneficiaryID}
                                                visitToken={
                                                    from !== ""
                                                        ? share?.token
                                                        : undefined
                                                }
                                            />
                                        );

                                    if (stream)
                                        return (
                                            <StreamBox
                                                key={share.id}
                                                created={share?.created || ""}
                                                updated={share?.updated || ""}
                                                from={from}
                                                to={to}
                                                sharedTo={sharedTo}
                                                stream={stream}
                                                onDelete={() =>
                                                    handleDeleteClick(share, false)
                                                }
                                                benId={share.beneficiaryID}
                                                visitToken={
                                                    from !== ""
                                                        ? share?.token
                                                        : undefined
                                                }
                                            />
                                        );

                                    return null;
                                },
                            })
                        }

                    </div>
                </div>
            </div>






        </div>

    ) : (
        <Login />
    );
};

export default IndividualShares;
